import { useDebounce } from '@vueuse/core';
import { Ref, watch } from 'vue';

export function useDebouncedRef(
  debounceFn: () => void,
  refs: [Ref<unknown>, ...Ref<unknown>[]],
  timer = 300,
) {
  const debouncedRefs = refs.map((ref) => useDebounce(ref, timer));
  watch(debouncedRefs, debounceFn);
}
